'use client';

import { createContext } from 'react';

import type { InputChipContextInterface } from '../types/input-chip-root.types';

export const InputChipContext = createContext<InputChipContextInterface>({
  labelText: '',
  setLabelText: () => {},
});

InputChipContext.displayName = 'InputChip.Context';
